export default {
    install(Vue: any) {
        // value 需要过滤的数据，例如[{id:1,name:'语文'},{id:1,name:'语文'}]
        // key 拼接字段1 
        // key2 拼接字段2,跟字段1之间用-分隔
        Vue.filter('objArrFormat', (value: any, key: any, key2?: any) => {
            if (!value || value.length == 0) {
                return '/'
            } else {
                if (!key) {
                    return value.join('、');
                } else {
                    let str: any = ''
                    value.forEach((ele: any) => {
                        if (str) {
                            str += '、'
                        }
                        str += ele[key];
                        if (key2) {
                            str += '-' + ele[key2]
                        }

                    });
                    return str
                }
            }
        });
        // value 需要过滤的数据，例如["数学", "语文", "英语"]
        // space 分隔符，默认、
        Vue.filter('strArrFormat', (value: any, space: any = '、') => {
            let str: any = '';
            if (value && value.length > 0) {
                value.forEach((ele: any) => {
                    if (str) {
                        str += space;
                    }
                    str += ele;
                });
            }
            return str;
        });
        // value 需要过滤的数据，例如"Wed Nov 29 2023 17:37:42 GMT+0800 (中国标准时间)"或者“2019-12-25 10:21:55”
        // format 格式
        // space 分隔符
        Vue.filter('dataFormat', (value: any, format: any = 'yyyy-MM-dd HH:mm:ss', space: any = '-') => {
            const now: any = new Date(value);
            const year: any = now.getFullYear(); // 得到年份
            let month: any = now.getMonth(); // 得到月份
            let date: any = now.getDate(); // 得到日期
            let hour: any = now.getHours(); // 得到小时
            let minu: any = now.getMinutes(); // 得到分钟
            let sec: any = now.getSeconds(); // 得到秒
            month = month + 1;
            if (month < 10) {
                month = "0" + month;
            }
            if (date < 10) {
                date = "0" + date;
            }
            if (hour < 10) {
                hour = "0" + hour;
            }
            if (minu < 10) {
                minu = "0" + minu;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }
            let time = "";
            if (format == "yyyy") {
                time = year
            } else if (format == "yyyy-MM") {
                time = year + "-" + month
            } else if (format == "yyyy-MM-dd") {
                time = year + "-" + month + "-" + date
            } else if (format == "yyyy-MM-dd HH") {
                time = year + "-" + month + "-" + date + " " + hour
            } else if (format == "yyyy-MM-dd HH:mm") {
                time = year + "-" + month + "-" + date + " " + hour + ":" + minu
            } else if (format == "yyyy-MM-dd HH:mm:ss") {
                time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
            }
            return time;
        });
        /**
         * @description 性别过滤，0未知，1男，2女
         */
        Vue.filter('genderFormat', (value: any) => {
            if (value === 0) {
                return '未知'
            } else if (value === 1) {
                return '男'
            } else if (value === 2) {
                return '女'
            } else {
                return ''
            }
        });
        /**
        * @description 四诊content的result拼接
        * @value 需要拼接的原数据,舌、面是arr,脉是obj
        * @type 舌、面、脉
        */
        Vue.filter('sizhenResultFormat', (value: any) => {
            let type: any = value.template_data ? value.template_data[0].type : value.data[0].type;
            let str: any = '';
            if (!value.report) {
                return ''
            }
            if (type == '舌象') {
                if (value.report['舌象信息输出']) {
                    const keys = ['舌色', '边尖红', '瘀斑瘀点', '苔色', '厚薄', '厚薄', '腻', '腐', '苔剥', '胖瘦', '齿痕', '点刺', '裂纹']
                    const d: any = value.report['舌象信息输出']
                    keys.forEach((ele: any, index: any) => {
                        if (d[index]) {
                            if (str) {
                                str += '；';
                            }
                            str += ele + "：" + d[index]
                        }

                    });
                }
            } else if (type == '舌象80' || type == '舌象100') {
                if (value.report['舌象信息']) {
                    const keys = ['舌神', '舌色', '舌形', '舌态', '苔质', '苔色']
                    const d: any = value.report['舌象信息']
                    keys.forEach((ele: any, index: any) => {
                        if (d[ele] && (d[ele][0].length > 0 || d[ele][0].length > 0)) {
                            if (str) {
                                str += '；';
                            }
                            str += ele + '：'
                            if (d[ele][0].length > 0) {
                                str += d[ele][0].join('、')
                            }
                            if (d[ele][1].length > 0) {
                                if (d[ele][0].length > 0) {
                                    str += '、'
                                }
                                str += d[ele][1].join('、')
                            }

                        }

                    });
                }
                // 拼舌100的数据
                if (value.report['舌100']) {
                    const keys = ['齿痕数量', '齿痕面积', '舌裂纹数量', '舌裂纹长度', '瘀斑数量', '瘀斑面积', '点刺数量', '点刺面积', '舌质颜色不均匀度', '舌苔颜色不均匀度']
                    const d: any = value.report['舌100']
                    keys.forEach((ele: any, index: any) => {
                        if (d[ele]) {
                            if (str) {
                                str += '；';
                            }
                            str += ele + "：" + d[ele]
                        }
                    });
                }
            }
            else if (type == '舌底') {
                if (value.report['舌底信息']) {
                    const keys: any = ['长度', '形态', '颜色', '粗细'];
                    const d: any = value.report['舌底信息'];
                    keys.forEach((ele: any, index: any) => {
                        if (d[ele]) {
                            if (str) {
                                str += '；';
                            }
                            str += ele + "：" + d[ele]
                        }
                    });
                }
            } else if (type == '面象') {
                if (value.report['面象信息输出']) {
                    const keys: any = ['面色', '两颧红', '眼眶黑', '光泽', '唇色'];
                    const d: any = value.report['面象信息输出']
                    keys.forEach((ele: any, index: any) => {
                        if (d[index]) {
                            if (str) {
                                str += '；';
                            }
                            str += ele + "：" + d[index]
                        }
                    });
                }

            } else if (type == '面象15') {
                if (value.report['面象信息']) {
                    const keys: any = ['面色', '唇态', '唇色', '鼻光泽', '鼻形态', '鼻颜色', '人中形态', '人中颜色','面部光泽','面部局部特征'];
                    const d: any = value.report['面象信息'];
                    keys.forEach((ele: any, index: any) => {
                        if (d[ele] && d[ele].length > 0) {
                            if (str) {
                                str += '；';
                            }
                            str += ele + "：" + d[ele].join('、')
                        }
                    });
                }
            } else if (type == '脉象') {
                if (value.report['左手脉象信息输出'] && value.report['左手脉象信息输出']['脉名']) {
                    str = '左脉：' + value.report['左手脉象信息输出']['脉名']
                }
                if (value.report['右手脉象信息输出'] && value.report['右手脉象信息输出']['脉名']) {
                    if (str) {
                        str += '；'
                    }
                    str += '右脉：' + value.report['右手脉象信息输出']['脉名']
                }
            } else if (type = '脉象6') {
                const tyep = value.report.pulse_hand + value.report.pulse_pos;
                if (value.report['脉象信息输出'] && value.report['脉象信息输出']['脉名']) {
                    str = tyep + '：' + value.report['脉象信息输出']['脉名']
                }
            }
            return str
        });

    },
};